import { defineAction } from '~/prix'
import fetchAllStreetsAction from './geoFetchAllStreets.action.json'
import { z } from 'zod'

const fetchAllStreetsDefinition = defineAction({
  ...fetchAllStreetsAction,

  input: z.object({
    update: z.boolean().default(true).describe('Força atualização de registros'),
    municipalityOsmCode: z.string().nullish().default(null).describe('Código OSM do município.'),
  }),
  output: z.object({}),
})

export default fetchAllStreetsDefinition
